export const getPersistableState = (moduleState) => {
    try {
        return {
            bookingForm: {
                savedAmenityViewMode: moduleState.bookingForm.savedAmenityViewMode,
            },
            filters: {
                dateRangeStart: moduleState.filters.dateRangeStart,
                dateRangeEnd: moduleState.filters.dateRangeEnd,
                category: moduleState.filters.category,
                amenity: moduleState.filters.amenity,
                searchTerm: moduleState.filters.searchTerm,
                status: moduleState.filters.status,
                multiFilter: moduleState.filters.multiFilter,
            }
        };
    } catch {
        return {};
    }
}
